import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=5a7d15fc&scoped=true&xmlns%3Av-slot=https%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=5a7d15fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d15fc",
  null
  
)

export default component.exports